import { set } from 'lodash';

function applyLocalDevOverrides() {
  try {
    if (process.env.NODE_ENV === 'development') {
      // override config with local development values
      // eslint-disable-next-line
      const config = require('./config.override.js');
      window.config = { ...window.config, ...config };
    }
  } catch (err) {
    // do nothing
  }
}

function applyQueryParamOverrides() {
  if (URLSearchParams) {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.forEach((value, key) => {
      let parsedValue = value;

      try {
        parsedValue = JSON.parse(value);
      } catch (error) {
        // do nothing
      }

      set(window.config, key, parsedValue);
    });
  }
}

applyLocalDevOverrides();
applyQueryParamOverrides();
